import React from "react";
import { Link } from "react-router-dom";
import directorImg from "../images/director.jpg"; // Add your director image here

import "./AboutUs.css";

const AboutUs = () => {
  return (
    <div style={styles.container}>
      {/* Hero Section */}
      <section style={styles.heroSection}>
        <h1 style={styles.heroTitle}>Global Certification</h1>
        <p style={styles.heroSubtitle}>
          Empowering Businesses with Trusted ISO Certifications
        </p>
      </section>

      {/* Company Intro */}
      <section style={styles.card}>
        <h2 style={styles.sectionTitle}>About Company</h2>
        <p style={styles.text}>
          <strong>Global Certification</strong> is a leading
          independent certification body committed to delivering
          internationally recognized ISO certifications. With integrity,
          transparency, and innovation as our core values, we help organizations
          achieve global quality standards and business excellence.
        </p>
        <p style={styles.text}>
          We have successfully partnered with organizations from various
          sectors — manufacturing, IT, education, healthcare, and more —
          providing certification, audit, and consultancy services that ensure
          growth and global credibility.
        </p>
      </section>

      {/* Company Profile */}
      <section style={styles.card}>
        <h2 style={styles.sectionTitle}>Company Profile</h2>
        <p style={styles.text}>
          <strong>Global Certification</strong> provides a full range
          of ISO Certifications including{" "}
          <strong>
            ISO 9001 (Quality Management), ISO 14001 (Environmental Management),
            ISO 45001 (Occupational Health & Safety), ISO 22000 (Food Safety),
            and ISO 27001 (Information Security)
          </strong>
          . Our services are designed to make your certification process smooth,
          cost-effective, and globally compliant.
        </p>
      </section>

      {/* Director Section */}
      <section style={styles.directorSection}>
        <div style={styles.directorImageBox}>
          <img src={directorImg} alt="Director" style={styles.directorImage} />
        </div>
        <div style={styles.directorInfo}>
          <h2 style={styles.sectionTitle}>About Director</h2>
          <p style={styles.text}>
            <strong>Mr. Vinod Kolhe</strong> is the Managing Director of{" "}
            <strong>Global Certification</strong>, with over 15 years
            of experience in ISO certification, management systems, and quality
            assurance. Under his leadership, the company has established itself
            as a symbol of trust, excellence, and credibility in the field of
            ISO certification.
          </p>
          <p style={styles.text}>
            His vision and dedication continue to guide the organization towards
            delivering unmatched quality and global recognition.
          </p>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section style={styles.missionVision}>
        <div style={styles.missionBox}>
          <h2 style={styles.missionTitle}>Our Mission</h2>
          <p style={styles.missionText}>
            To assist organizations in achieving excellence through global
            quality standards, promoting sustainable growth, and empowering
            industries with the right management systems.
          </p>
        </div>

        <div style={styles.visionBox}>
          <h2 style={styles.missionTitle}>Our Vision</h2>
          <p style={styles.missionText}>
            To be a globally trusted certification body recognized for integrity,
            innovation, and commitment towards delivering quality-driven
            solutions.
          </p>
        </div>
      </section>

      {/* Our Approach */}
      <section style={styles.card}>
        <h2 style={styles.sectionTitle}>Our Approach</h2>
        <p style={styles.text}>
          Our approach is simple yet effective — we understand every client’s
          unique goals and challenges. We offer tailored certification
          solutions, expert guidance, and continuous support to help you build
          a resilient management system aligned with global standards.
        </p>
      </section>

      {/* Footer Section */}
      <footer style={styles.footer}>
        <div style={styles.footerContent}>
          <div>
            <h3 style={styles.footerHeading}>Global Certification</h3>
            <p style={styles.footerText}>
              15A, Navjivan Colony, Wardha Road, Narendra Nagar, Nagpur - 440015
            </p>
          </div>

          <div>
            <h3 style={styles.footerHeading}>Quick Links</h3>
            <ul style={styles.footerList}>
              <li>
                <Link to="/about-us" style={styles.footerLink}>About Us</Link>
              </li>
              <li>
                <Link to="/services-iso-standards" style={styles.footerLink}>Services</Link>
              </li>
              <li>
                <Link to="/gallery" style={styles.footerLink}>Gallery</Link>
              </li>
              <li>
                <Link to="/contact-us" style={styles.footerLink}>Contact Us</Link>
              </li>
              <li>
                <Link to="/contact-us" style={styles.footerLink}>Location</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 style={styles.footerHeading}>Follow Us</h3>
            <p style={styles.footerText}>Facebook | LinkedIn | YouTube</p>
          </div>
        </div>
        <div style={styles.footerBottom}>
          © {new Date().getFullYear()} Global Certification. All Rights Reserved.
        </div>
      </footer>
    </div>
  );
};

// =======================
// Styles
// =======================
const styles = {
  container: {
    fontFamily: "Poppins, sans-serif",
    background: "linear-gradient(to bottom right, #f4f7ff, #e8efff)",
    color: "#333",
    width: "100%",
    minHeight: "100vh",
    overflowX: "hidden",
  },

  heroSection: {
    background: "linear-gradient(90deg, #0A1D56, #1446A0)",
    color: "#fff",
    textAlign: "center",
    padding: "90px 20px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.3)",
    width: "100%",
    boxSizing: "border-box",
  },

  heroTitle: {
    fontSize: "42px",
    fontWeight: "700",
    marginBottom: "10px",
    letterSpacing: "1px",
    lineHeight: "1.2",
  },

  heroSubtitle: {
    fontSize: "20px",
    fontWeight: "400",
    opacity: "0.9",
    lineHeight: "1.6",
  },

  card: {
    backgroundColor: "#fff",
    margin: "40px auto",
    maxWidth: "1000px",
    width: "calc(100% - 40px)",
    padding: "35px 40px",
    borderRadius: "16px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    boxSizing: "border-box",
  },

  sectionTitle: {
    color: "#0A1D56",
    fontSize: "24px",
    borderBottom: "3px solid #FF7F50",
    display: "inline-block",
    marginBottom: "20px",
    paddingBottom: "5px",
    fontWeight: "600",
    lineHeight: "1.3",
  },

  text: {
    fontSize: "17px",
    lineHeight: "1.8",
    marginBottom: "15px",
    color: "#444",
  },

  directorSection: {
    display: "flex",
    alignItems: "stretch",
    justifyContent: "center",
    flexWrap: "wrap",
    backgroundColor: "#fff",
    maxWidth: "1000px",
    width: "calc(100% - 40px)",
    margin: "40px auto",
    borderRadius: "16px",
    boxShadow: "0 8px 20px rgba(0,0,0,0.08)",
    overflow: "hidden",
    boxSizing: "border-box",
  },

  directorImageBox: {
    flex: "1",
    minWidth: "280px",
    maxWidth: "450px",
  },

  directorImage: {
    width: "100%",
    height: "100%",
    minHeight: "300px",
    objectFit: "cover",
    display: "block",
  },

  directorInfo: {
    flex: "2",
    padding: "30px 40px",
    boxSizing: "border-box",
  },

  missionVision: {
    display: "flex",
    justifyContent: "center",
    alignItems: "stretch",
    gap: "25px",
    flexWrap: "wrap",
    margin: "50px auto",
    maxWidth: "1000px",
    width: "calc(100% - 40px)",
    boxSizing: "border-box",
  },

  missionBox: {
    flex: "1",
    backgroundColor: "#0A1D56",
    color: "#fff",
    borderRadius: "15px",
    padding: "30px",
    minWidth: "280px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
    boxSizing: "border-box",
  },

  visionBox: {
    flex: "1",
    backgroundColor: "#FF7F50",
    color: "#fff",
    borderRadius: "15px",
    padding: "30px",
    minWidth: "280px",
    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
    boxSizing: "border-box",
  },

  missionTitle: {
    fontSize: "22px",
    fontWeight: "600",
    marginBottom: "15px",
  },

  missionText: {
    fontSize: "16px",
    lineHeight: "1.8",
  },

  footer: {
    backgroundColor: "#0A1D56",
    color: "#fff",
    padding: "60px 20px 25px",
    marginTop: "60px",
    width: "100%",
    boxSizing: "border-box",
  },

  footerContent: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "flex-start",
    flexWrap: "wrap",
    gap: "30px",
    marginBottom: "30px",
  },

  footerHeading: {
    color: "#FF7F50",
    fontSize: "18px",
    marginBottom: "10px",
  },

  footerText: {
    fontSize: "15px",
    lineHeight: "1.8",
  },

  footerList: {
    listStyle: "none",
    padding: 0,
    margin: 0,
    fontSize: "15px",
    lineHeight: "1.8",
  },

  footerLink: {
    color: "#fff",
    textDecoration: "none",
    transition: "color 0.3s ease",
  },

  footerBottom: {
    textAlign: "center",
    fontSize: "14px",
    borderTop: "1px solid rgba(255,255,255,0.2)",
    paddingTop: "15px",
    lineHeight: "1.6",
  },
};

export default AboutUs;
